import React, {useEffect, useState} from "react";
import {Autocomplete, Box, TextField, Typography} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {fetchWalletsAndGroups, selectActiveWalletsOrSelected} from "../../store/walletSlice";
import {fetchCurrencies} from "../../store/currencySlice";
import AmountWithCurrency from "../layout/AmountWithCurrency";
import {useTranslation} from "react-i18next";

const WalletSelect = ({selectedWalletId, label, onChange, width = "75%", sx, error = false, helperText = null}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const wallets = useSelector(state => selectActiveWalletsOrSelected(state, selectedWalletId));
    const [inputText, setInputText] = useState("");

    useEffect(() => {
        dispatch(fetchWalletsAndGroups());
        dispatch(fetchCurrencies());
    }, []);

    // Find the selected wallet object
    const selectedWallet = wallets.find(wallet => wallet.id == selectedWalletId);

    return (
        <Autocomplete
            sx={{...sx, display: 'inline-flex', width: width}}
            onChange={(event, newSelectedWallet) => {
                onChange(newSelectedWallet ? newSelectedWallet.id : null);
            }}
            options={wallets} // Pass the actual wallet objects, not just IDs
            getOptionLabel={(wallet) => wallet ? wallet.name : ""}
            value={selectedWallet || null} // Use the wallet object or null
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            renderOption={(props, wallet) => (
                <Box {...props} key={wallet.id}>
                    <Typography variant='body1'>
                        {wallet.name} - (<AmountWithCurrency amount={wallet.balance} currencyId={wallet.currency}/>)
                    </Typography>
                </Box>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    onChange={(e) => { setInputText(e.target.value); }}
                    label={label || t("common.labels.wallet")}
                    variant="standard"
                    sx={{width: "100%"}}
                    error={!!error}
                    helperText={helperText}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: "off",
                    }}
                />
            )}
        />
    );
};

export default WalletSelect;